export enum HolidayNames {
  BLACK_FRIDAY = "Black Friday",
  CHRISTMAS_DAY = "Christmas Day",
  CHRISTMAS_EVE = "Christmas Eve",
  COLUMBUS_DAY = "Columbus Day",
  INDEPENDENCE_DAY = "Independence Day",
  JUNETEENTH = "Juneteenth",
  LABOR_DAY = "Labor Day",
  MARTIN_LUTHER_KING_JR_DAY = "Martin Luther King Jr. Day",
  MEMORIAL_DAY = "Memorial Day",
  NEW_YEARS_DAY = "New Year's Day",
  NEW_YEARS_EVE = "New Year's Eve",
  PRESIDENTS_DAY = "Presidents Day",
  THANKSGIVING = "Thanksgiving",
  VETERANS_DAY = "Veterans Day",
}
